module.exports = new __parcel__URL__("glacialencapsulationcancel.c20e467e.png").toString();